import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map, StorageUtil } from '../store';
import * as lodash from 'lodash';
import * as moment from 'moment';
import { max } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class InjuryService {


  // url = '/api/workout';
  url = '/api/injury';

  constructor(
    private hs: HttpService
  ) { }

  loadInjuryDetails(injuryID: number) {
    return this.hs.get(`${this.url}/load-injury-details/${injuryID}`);
  }

  loadAllInjuredPlayersByTeamID(teamID: number) {
    return this.hs.get(`${this.url}/load-all-injured-players-by-team-id/${teamID}`);
  }

  loadAllInjuredPlayersByClubID(clubID: number) {
    return this.hs.get(`${this.url}/load-all-injured-players-by-club-id/${clubID}`);
  }

  loadAllChartDataByTeamID(teamID: number, clubID: number) {
    return this.hs.get(`${this.url}/load-all-chart-data-by-team-id/${teamID}/${clubID}`);
  }

  loadAllChartDataByClubID(clubID: number) {
    return this.hs.get(`${this.url}/load-all-chart-data-by-club-id/${clubID}`);
  }

  loadAllPlayerInjuriesByPlayersID(playerID: number, teamID: number) {
    return this.hs.get(`${this.url}/load-all-player-injuries-by-player-id/${playerID}/${teamID}`);
  }

  loadChartDataByPlayerID(playerID: number, teamID: number) {
    return this.hs.get(`${this.url}/load-chart-data-by-player-id/${playerID}/${teamID}`);
  }

  loadInjuryInformations(){
    return this.hs.get(`${this.url}/load-injury-informations`);
  }

  loadInjuryHistory(injuryID: number){
    return this.hs.get(`${this.url}/load-injury-history/${injuryID}`);
  }

  addInjuryToPlayer(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.hs.post(this.url + '/add-injury-to-player', payload, httpOptions);
  }

  updatPlayerInjury(injuryID: number,payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    console.log("Payload ==> ", payload)
    return this.hs.post(this.url + '/update-player-injury/'+injuryID, payload, httpOptions);
  }

  addNoteToInjury(addInjuryNotePayload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    console.log("Payload ==> ", addInjuryNotePayload)
    return this.hs.post(this.url + '/add-note-to-injury', addInjuryNotePayload, httpOptions);
  }

  addDocumentToInjury(addInjuryNotePayload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    console.log("Payload ==> ", addInjuryNotePayload)
    return this.hs.post(this.url + '/add-document-to-injury', addInjuryNotePayload, httpOptions);
  }

  removePlayerInjuries(injuryIDs: string) {
    return this.hs.delete(this.url + '/remove-player-injuries/'+injuryIDs);
  }

  removePlayerInjuryNotes(injurynoteIDs: string) {
    return this.hs.delete(this.url + '/remove-player-injury-notes/'+injurynoteIDs);
  }

  removePlayerInjuryDocuments(injurydocumentIDs: string) {
    return this.hs.delete(this.url + '/remove-player-injury-documents/'+injurydocumentIDs);
  }

  loadTeamsByGenderAndClubID(clubID: number, teamGender: number) {
    return this.hs.get(this.url + '/load-teams-by-gender-and-club-id/'+clubID+'/'+teamGender);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/injury.service .ts